export default __webpack_public_path__ + "static/media/imotosplash.3e150039.jpg";